import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import { TEST_OR_QUIZ } from "assessments/constants"
import ConnectStores from "lib/core/store/components/ConnectStores"
import { LEARN } from "path/constants"
import { ALLOW_RESETS } from "step/constants"
import StepPermissionLock from "../lock/StepPermissionLock"
import StepCompletion from "./StepCompletion"

const StepCompletionContainer = function (props) {
  if (!props.isLoading) {
    if (props.step_permissions.can_complete) {
      return <StepCompletion {...Object.assign({}, props)} />
    } else {
      return (
        <StepPermissionLock message="Register now to track your progress, view discussions, and more." />
      )
    }
  } else {
    return <LoadingCircle />
  }
}

StepCompletionContainer.displayName = "StepCompletionContainer"

const mapStateToProps = function (state, ownProps) {
  const { resourceStore, stepStore, pathStore } = state

  const {
    comment,
    step,
    step_completion_error,
    completion,
    is_skipping_step,
    completion_loading,
    is_completing_step,
    is_reseting_completion,
    content,
    content_loading
  } = stepStore.state

  const { path, mode } = pathStore.state

  const canResetStep = !content_loading
    ? content?.assessment?.assessment_type !== TEST_OR_QUIZ &&
      (!content || content.type === "blocks"
        ? (step.allow_resets !== ALLOW_RESETS.BEFORE || mode > LEARN) &&
          // no one, not even admin can reset a step from the path when step requires_api_completion
          // unless that step is optional and is not overridden by api
          // though admin can reset same step from path progress
          (!completion ||
            !completion.requires_api_completion ||
            (!completion.is_required && !completion.overridden_by_api)) &&
          // learner cannot reset step whose completion state has been overridden by another user
          !step?.completion?.overridden_by?.id !== step?.completion?.user?.id
        : true)
    : false

  const { permissions: step_permissions } = step

  const permissions = resourceStore.request.permissions()

  // const completions_url = `${path.url}${path.id}/completion/?step=${
  //   step.sync_source_id
  // }`
  const completions_url = `completion/?source_id=${step.sync_source_id}`
  const nextStep = stepStore.request.getNextItem()

  const isLoading = completion_loading || !completion

  let canComplete = !ownProps.isCompletionDisabled
  const commentRequired = step.completion_comment_required_status === "R"
  if (commentRequired) {
    canComplete =
      canComplete && (comment != null ? comment.length : undefined) > 0
  }

  const props = _.assign(
    {},
    {
      nextStep,
      canComplete,
      step,
      step_permissions,
      step_completion_error,
      completion,
      is_skipping_step,
      is_completing_step,
      is_reseting_completion,
      permissions,
      completions_url,
      isLoading,
      mode,
      canResetStep,
      content,
      onCompleteStep() {
        return stepStore.action.completeStep(
          false /* skip */,
          ownProps.completionToken
        )
      },
      onResetStep() {
        if (step.content && step.content.type === "assessment") {
          return stepStore.action.resetAssessment()
        } else {
          return stepStore.action.resetStep()
        }
      },
      onSkipStep() {
        return stepStore.action.skipStep(ownProps.completionToken)
      }
    },
    ownProps
  )
  return props
}

const completionWatchKeys = [
  "comment",
  "completion",
  "is_completing_step",
  "is_reseting_completion",
  "is_skipping_step",
  "step_completion_error",
  "content",
  "content_loading"
]

const pathItemWatchKeys = ["items"]

const stores = [
  { store: "resource", watch: ["offering"] },
  { store: "step", watch: completionWatchKeys },
  { store: "path", watch: pathItemWatchKeys }
]

export default ConnectStores(
  StepCompletionContainer,
  stores,
  {},
  mapStateToProps,
  true
)
